import React, { Component, createRef, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import TableCell from "@material-ui/core/TableCell";

import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../StudentMarksDetail.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";

class ObtainedMarksRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      marksData: {
        subjectName: "",
        theory: 0,
        practical: 0,
        status: "",
        resultStatus: "",
      },
      newMarksStatus: true,
      oldMarksStatus: false,
      marksRef: createRef(),
      existingMarks: [],
    };
  }

  handleNewMarksStatus = (newMarksStatus) => {
    this.setState({
      newMarksStatus,
    });
  };

  handleStatusChange = (e) => {
    this.setState({
      marksData: {
        ...this.state.marksData,
        subjectName: e.target.name,
        status: e.target.value,
      },
    });
  };

  handleResultStatus = (e) => {
    this.setState({
      marksData: {
        ...this.state.marksData,
        subjectName: e.target.name,
        resultStatus: e.target.value,
      },
    });
  };

  handleTheoryMarks = (e) => {
    this.setState({
      marksData: {
        ...this.state.marksData,
        subjectName: e.target.name,
        theory: e.target.value,
      },
    });
  };

  handlePracticalMarks = (e) => {
    this.setState({
      marksData: {
        ...this.state.marksData,
        subjectName: e.target.name,
        practical: e.target.value,
      },
    });
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  handleEdit = (marksType, data) => {
    this.setState({
      marksData: {
        subjectName: data.subjectName,
        theory: data.theory,
        practical: data.practical,
        status: data.status,
        resultStatus: data.resultStatus,
      },
    });
    if (marksType === "new") {
      this.handleNewMarksStatus(true);
    } else {
      this.handleOldMarkStatus(true);
    }
  };

  handleOldMarkStatus = (oldMarksStatus) => {
    this.setState({
      oldMarksStatus,
    });
  };

  handleAdd = (marksType, data) => {
    this.setState({
      marksData: {
        subjectName: data.subjectName,
        theory: data.theory,
        practical: data.practical,
        status: data.status,
      },
    });
    if (marksType === "new") {
      this.handleNewMarksStatus(false);
    } else {
      this.handleOldMarkStatus(false);
    }
    this.props.handleMarks(data);
  };

  render() {
    const { marksData } = this.state;
    const { classes, index, data } = this.props;
    return this.props.marksStatus ? (
      this.state.newMarksStatus ? (
        <Fragment>
          <TableCell align="center">{index + 1}</TableCell>
          <TableCell align="center" style={{ fontWeight: "bold" }}>
            {data.subjectName}
          </TableCell>
          <TableCell align="center">
            <TextField
              name={data.subjectName}
              select
              required
              variant="outlined"
              style={{ marginRight: 10 }}
              SelectProps={{
                native: true,
                classes: {
                  select: classes.selectRoot,
                },
              }}
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={marksData.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Select Any One</option>
              <option value="Present">Present</option>
              <option value="Absent">Absent</option>
            </TextField>
          </TableCell>
          <TableCell align="center">
            <TextField
              name={data.subjectName}
              required
              type="number"
              variant="outlined"
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
                inputProps: {
                  min: 0,
                  max: 100,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              inputRef={this.state.marksRef}
              onWheel={() => this.handleWheel(this.state.marksRef)}
              value={marksData.theory}
              onChange={this.handleTheoryMarks}
            />
          </TableCell>
          <TableCell align="center">
            <TextField
              name={data.subjectName}
              required
              type="number"
              variant="outlined"
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
                inputProps: {
                  min: 0,
                  max: 100,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              inputRef={this.state.marksRef}
              onWheel={() => this.handleWheel(this.state.marksRef)}
              value={marksData.practical}
              onChange={this.handlePracticalMarks}
            />
          </TableCell>
          <TableCell align="center">
            <TextField
              name={data.subjectName}
              select
              required
              variant="outlined"
              style={{ marginRight: 10 }}
              SelectProps={{
                native: true,
                classes: {
                  select: classes.selectRoot,
                },
              }}
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={marksData.resultStatus}
              onChange={this.handleResultStatus}
            >
              <option value="">Select Any One</option>
              <option value="Pass">Pass</option>
              <option value="Fail">Fail</option>
            </TextField>
          </TableCell>
          <TableCell align="center">
            <Tooltip
              arrow
              title="Add Marks"
              className={classes.tooltip}
              onClick={() => this.handleAdd("new", this.state.marksData)}
            >
              <AddCircleIcon />
            </Tooltip>
          </TableCell>
        </Fragment>
      ) : (
        <Fragment>
          <TableCell align="center">{index + 1}</TableCell>
          <TableCell align="center">
            <b>{data.subjectName}</b>
          </TableCell>
          {data.status === "Present" ? (
            <TableCell
              align="center"
              style={{ color: "green", fontWeight: "bold" }}
            >
              Present
            </TableCell>
          ) : (
            <TableCell
              align="center"
              style={{ color: "red", fontWeight: "bold" }}
            >
              Absent
            </TableCell>
          )}
          <TableCell align="center">{data.theory}</TableCell>
          <TableCell align="center">{data.practical}</TableCell>
          {data.resultStatus === "Pass" ? (
            <TableCell
              align="center"
              style={{ color: "green", fontWeight: "bold" }}
            >
              Pass
            </TableCell>
          ) : (
            <TableCell
              align="center"
              style={{ color: "red", fontWeight: "bold" }}
            >
              Fail
            </TableCell>
          )}
          <TableCell align="center">
            <Tooltip
              arrow
              title="Edit Marks"
              className={classes.tooltip}
              onClick={() => this.handleEdit("new", data)}
            >
              <EditIcon />
            </Tooltip>
          </TableCell>
        </Fragment>
      )
    ) : this.state.oldMarksStatus === false ? (
      <Fragment>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          <b>{data.subjectName}</b>
        </TableCell>
        {data.status === "Present" ? (
          <TableCell
            align="center"
            style={{ color: "green", fontWeight: "bold" }}
          >
            Present
          </TableCell>
        ) : (
          <TableCell
            align="center"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Absent
          </TableCell>
        )}
        <TableCell align="center">{data.theory}</TableCell>
        <TableCell align="center">{data.practical}</TableCell>
        {data.resultStatus === "Pass" ? (
          <TableCell
            align="center"
            style={{ color: "green", fontWeight: "bold" }}
          >
            Pass
          </TableCell>
        ) : (
          <TableCell
            align="center"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Fail
          </TableCell>
        )}
        <TableCell align="center">
          <Tooltip
            arrow
            title="Edit Marks"
            className={classes.tooltip}
            onClick={() => this.handleEdit("old", data)}
          >
            <EditIcon />
          </Tooltip>
        </TableCell>
      </Fragment>
    ) : (
      <Fragment>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center" style={{ fontWeight: "bold" }}>
          {data.subjectName}
        </TableCell>
        <TableCell align="center">
          <TextField
            name={data.subjectName}
            select
            required
            variant="outlined"
            style={{ marginRight: 10 }}
            SelectProps={{
              native: true,
              classes: {
                select: classes.selectRoot,
              },
            }}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={marksData.status}
            onChange={this.handleStatusChange}
          >
            <option value="">Select Any One</option>
            <option value="Present">Present</option>
            <option value="Absent">Absent</option>
          </TextField>
        </TableCell>
        <TableCell align="center">
          <TextField
            name={data.subjectName}
            required
            type="number"
            variant="outlined"
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: {
                min: 0,
                max: 100,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.marksRef}
            onWheel={() => this.handleWheel(this.state.marksRef)}
            value={marksData.theory}
            onChange={this.handleTheoryMarks}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name={data.subjectName}
            required
            type="number"
            variant="outlined"
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: {
                min: 0,
                max: 100,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            inputRef={this.state.marksRef}
            onWheel={() => this.handleWheel(this.state.marksRef)}
            value={marksData.practical}
            onChange={this.handlePracticalMarks}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name={data.subjectName}
            select
            required
            variant="outlined"
            style={{ marginRight: 10 }}
            SelectProps={{
              native: true,
              classes: {
                select: classes.selectRoot,
              },
            }}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={marksData.resultStatus}
            onChange={this.handleResultStatus}
          >
            <option value="">Select Any One</option>
            <option value="Pass">Pass</option>
            <option value="Fail">Fail</option>
          </TextField>
        </TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Edit Marks"
            className={classes.tooltip}
            onClick={() => this.handleAdd("old", this.state.marksData)}
          >
            <AddCircleIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Cancel Edit"
            className={classes.tooltip}
            onClick={() => this.handleOldMarkStatus(false)}
          >
            <CancelIcon />
          </Tooltip>
        </TableCell>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(ObtainedMarksRegister)));
